module.exports = __webpack_public_path__ + "img/utsuho reiuji_sc2.c7281b71.png";